/* istanbul ignore file */

// CookieHub consent management script loader
// Only loads in non-localhost environments
// @see src/types/analytics/tracking.types.ts for Window.cookiehub interface

import { logAppError } from '@/config/sentryConfig';
import { isLocalhost } from '@/utils/environment';

const cookieHubUrl = import.meta.env.VITE_COOKIE_HUB_URL;

if (cookieHubUrl && !isLocalhost) {
  const cookieHubPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script') as HTMLScriptElement;
    script.src = cookieHubUrl;
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', () => {
      reject(new Error(`Failed to load CookieHub script from ${cookieHubUrl}`));
    });
    document.head.appendChild(script);
  });

  cookieHubPromise
    .then(() => {
      window.cookiehub?.load({});
    })
    .catch((error: unknown) => {
      logAppError({
        error,
        functionName: 'cookieHubInit',
        section: 'cookieHub',
        message: 'Failed to load CookieHub script'
      });
    });
}
